export default __webpack_public_path__ + "static/media/p3plan-purplebg.86e9f2e5.png";